<div class="no-stations-container">
    <div class="no-stations-content">
        <div class="no-stations-icon-container">
            <fa-icon icon="tint" class="no-stations-primary-icon"></fa-icon>
            <fa-icon icon="tint" class="no-stations-secondary-icon"></fa-icon>
        </div>
        {{'STRINGS.NO_STATIONS_ARE_RUNNING' | translate}}
    </div>
</div>
